import { trans } from "./../helper/trans";
import { dimmer } from "../helper/dimmer";
import { humanDate } from "./../helper/humanDate";
import { fetchNews } from "../helper/fetchNews";

import { checkModes, toggleMode, updateBanner } from "./../helper/checkModes";
// helper function imports

import { lang } from "./../app";
// some imports from our global scope

// import { utility } from "./../helper/utility";
// utility();
// place inside ready function if necessary
// // db helper utility as needed (DO NOT RUN BEFORE
// UPDATING utility.js !!!!! )

let editLang = lang;
let news = [];
const modeCookie = document.cookie.split(";").find(item => item.indexOf("gnews_mode") > -1);
window.renderContent = async user => {
	const { userLevel } = user;
	const admin = userLevel.toLowerCase() === "admin";
	let adminArea = $(window).width() <= 600 ? $("#menu .admin_welcome") : $("header .admin_welcome");
	if (admin) {
		adminArea.append(`<span id="mode_wrapper">
					<span>
						<div class="uk-inline">
							<label>| Banner: </label>
						</div>
						<div class="uk-width-auto uk-inline">
							<label class="uk-switch small pointer" for="banner_mode">
								<input type="checkbox" name="banner_mode" id="banner_mode">
								<div class="uk-switch-slider"></div>
							</label>
						</div>
					</span> | <span>
						<div class="uk-inline">
							<label>Dark Mode: </label>
						</div>
						<div class="uk-width-auto uk-inline">
							<label class="uk-switch small pointer" for="darkpage_mode">
								<input type="checkbox" name="darkpage_mode" id="darkpage_mode">
								<div class="uk-switch-slider"></div>
							</label>
						</div>
					</span> |</span>`);
	}
	// create banner and dark mode checkboxex

	try {
		const newsParams = {
			reqId: admin ? "c6148d32-343e-4918-b0fb-53982f7412e0" : "644bff17-8cd7-46ea-b103-8d98ac019eaa",
			datatype: "release",
			filter: `#langs.#lang.#index BETWEEN :start AND :end${!admin ? " AND #langs.#lang.#status = :true AND #langs.#lang.#pubTime <=  :now" : ""}`,
			namesAdd: {
				"#langs": "langs",
				"#lang": lang,
				"#index": admin ? "index" : "aIndex"
			},
			valuesAdd: {
				":start": 0,
				":end": 9
			}
		};
		if (!admin) {
			newsParams.namesAdd["#status"] = "status";
			newsParams.namesAdd["#pubTime"] = "pubTime";
			newsParams.valuesAdd[":now"] = new Date().getTime();
			newsParams.valuesAdd[":true"] = true;
		}
		const response = await fetchNews(
			{
				container: $("body"),
				size: 2
			},
			news,
			"",
			newsParams,
			userLevel
		);
		news = response.data;
		try {
			let modes = await checkModes(modeCookie);
			buildNewsSection(news, userLevel, modes);
		} catch (err) {
			console.error("Error checking site mode:", err);
		}
		// check for which mode we're in
		// then build news section
	} catch (err) {
		console.error("Error retrieving news release data:", err);
	}
	// kick off news release gathering cascade
};
// end renderContent function

const buildNewsSection = async (news, userLevel, modes) => {
	let darkSettings = modes.find(item => item.id === "darkpage_setting");
	$("input[name='darkpage_mode']")
		.prop("checked", darkSettings.on)
		.off("change")
		.on("change", async function () {
			$(this).parent().append(dimmer(0.6));
			const mode = $(this).prop("checked");
			try {
				const response = await toggleMode("darkpage_setting", mode);
				$(this).off("change").parent().find(".dimmer").remove();
				darkSettings.on = mode;
				buildNewsSection(news, userLevel, modes);
			} catch (err) {
				$(this).parent().find(".dimmer").remove();
				console.error("Error fetching mode setting");
			}
		});
	// dark page mode toggle change handler

	let bannerSettings = modes.find(item => item.id === "banner_setting");
	$("input[name='banner_mode']")
		.prop("checked", bannerSettings.on)
		.off("change")
		.on("change", async function () {
			$(this).parent().append(dimmer(0.6));
			const mode = $(this).prop("checked");
			try {
				const response = await toggleMode("banner_setting", mode);
				$(this).off("change").parent().find(".dimmer").remove();
				bannerSettings.on = mode;
				buildNewsSection(news, userLevel, modes);
			} catch (err) {
				$(this).parent().find(".dimmer").remove();
				console.error("Error fetching banner settings");
			}
		});
	// banner mode toggle change handler
	let bannerText = bannerSettings.banner ? bannerSettings.banner[lang] : "";
	let bannerInput = `<div id="banner_input_wrapper" class="hidden container uk-flex uk-flex-middle">
            <form>        
                <div class="field">
                    <textarea id="bannerText" name="bannerText" placeholder="Enter banner text">${bannerText}</textarea>
                </div>
                <div class="field uk-margin-small-left">
                    <select class="caret uk-select" id="bannerLanguage" name="lang" value="${lang}">
                        <option ${lang === "en" ? "selected" : ""} value="en">English</option>
                        <option ${lang === "cn" ? "selected" : ""} value="cn">Chinese</option>
                        <option ${lang === "pt" ? "selected" : ""} value="pt">Portuguese</option>
                        <option ${lang === "ru" ? "selected" : ""} value="ru">Russian</option>
                        <option ${lang === "es" ? "selected" : ""} value="es">Spanish</option>
                    </select>
                    <span id="banner_accept" uk-icon="icon: check" class="text-green"></span> <span id="banner_reject" uk-icon="icon: close" class="text-red"></span>
                </div>
            </form>
        </div>`;
	let bannerEditor;

	let isSmall = $(window).width() <= 600;
	let ordered = [];
	let darkNews = false;
	let releasesWrapper = $("#releases_wrapper").html(bannerSettings.on && (bannerText || userLevel === "admin") ? `<div id="banner" class="uk-padding-small uk-light uk-text-center"><div id="banner_text_wrapper">${bannerText}</div>${bannerInput}<span id="banner_close_button" class="uk-align-right" uk-icon="icon: close"></span></div>` : "");
	// start new release wrapper with banner if set 'on'

	if (news.length) {
		news.sort((a, b) => {
			if (a.langs[lang].pubTime > b.langs[lang].pubTime) {
				return -1;
			} else if (a.langs[lang].pubTime < b.langs[lang].pubTime) {
				return 1;
			}
			return 0;
		});
		// sort descending by pubTime

		if (darkSettings.on) {
			darkNews = news.find(item => item.langs[lang].darkpage);
			// we're in dark mode; do we have a dark page item?
		}
		if (!darkNews) {
			let featured = news.find(item => item.langs[lang].featured);
			if (!featured) {
				featured = news.find(item => item.langs[lang].images && news[0].langs[lang].images.length);
			}
			// find first release in news that has
			// featured===true for this lang; if
			// none are found, set featured to be first item
			// that includes at least one image

			let orderedItems = 4;
			// how many items shall we show on the page after
			// the featured item?

			ordered = news
				.filter(item => featured && item.id != featured.id)
				.filter(item => item.langs[lang] && item.langs[lang].images && item.langs[lang].images.length)
				.slice(0, orderedItems);
			// remove featured item from news (if it exists)
			// and any items without a version in this language
			// or which do not have at least one image;
			// what remains is what's available for the
			// news display;
			// finally, remove items in excess of set 'orderedItems'
			let imageUrl;
			if (featured.langs[lang].images.length) {
				const image = featured.langs[lang].images[0];
				let preview = image.preview ? image.preview : image.url;
				let thumb = image.customthumb ? image.customthumb : image.src && image.src.toLowerCase() === "dam" ? image.url : image.thumb;
				imageUrl = preview ? preview : thumb;
			}
			let image = imageUrl ? `<a class="uk-width-1-1" href="/${lang}/news/?id=${featured.id}"><img src="${imageUrl}"/></a>` : "";
			releasesWrapper.append(`<div class="uk-hidden@s featured__block uk-text-center uk-padding uk-light">
                <div class="uk-heading-small">
                    ${trans("Newsroom")}
                </div>
                ${image ? `<div class="image_wrapper uk-width-1-1">${image}</div>` : ""}
                <div class="copy_wrapper uk-margin-large-top uk-margin-small-bottom">
                    <div class="headline uk-heading-large uk-margin-small-bottom">
                        <a href="/${lang}/news/?id=${featured.id}">${featured.langs[lang].headline}</a>
                    </div>
                    ${
						featured.langs[lang].subhead && featured.langs[lang].subhead != null
							? `<div class="subhead uk-margin-remove">
                        ${featured.langs[lang].subhead}
                    </div>`
							: ""
					}
                    <div class="pubDate uk-margin uk-margin-large-top">
                        ${humanDate(featured.langs[lang].pubTime)}
                    </div>
                </div>
            </div>
            <div uk-grid class="desktop_featured uk-visible@s featured__block uk-grid-collapse uk-child-width-expand">
                <div class="image_wrapper screen uk-width-auto uk-flex uk-flex-middle uk-flex-center uk-padding-large">
                    ${image ? image : ""}
                </div>
                <div class="copy_wrapper uk-width-expand uk-inline uk-text-center uk-light uk-flex uk-flex-center uk-flex-column">
                    <div class="newsroom_header uk-heading-small uk-padding-large uk-position-top">
                        ${trans("Newsroom")}
                    </div>
                    <div class="headline">
                        <a href="/${lang}/news/?id=${featured.id}">${featured.langs[lang].headline}</a>
                    </div>
                    <div class="subhead_date uk-position-bottom">
                        ${
							featured.langs[lang].subhead
								? `<div class="subhead uk-margin-small-bottom">
                            ${featured.langs[lang].subhead}
                        </div>`
								: ""
						}
                        <div class="pubDate">
                            ${humanDate(featured.langs[lang].pubTime)}
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-margin-bottom">
                <div class="uk-hidden@s block__header uk-heading-small uk-padding uk-padding-remove-vertical uk-text-center uk-margin-xlarge-top uk-margin-xlarge-bottom">
                    ${trans("Latest News Releases")}
                </div>
                <div class="uk-visible@s block__header uk-padding-large uk-padding-remove-vertical uk-heading-medium uk-text-center">
                    ${trans("Latest News Releases")}
                </div>

                <!-- ordered items go here -->
                <div id="ordered_items_wrapper">
					<div class="ordered_items ${isSmall ? "uk-padding" : "uk-padding-large"} uk-padding-remove-vertical" uk-grid></div>
                	</div>
				</div>

                <!-- all releases button -->
                <div class="uk-flex uk-flex-center uk-margin-large-top uk-margin-large-bottom">
                    <a class="button_anchor" href="/${lang}/news">
                        <button class="all_releases_button button uk-button uk-button-primary">${trans("All News Releases")}</button>
                    </a>
                </div>
            </div>`);
			if (ordered && ordered.length) {
				ordered.forEach(release => {
					let imageUrl = release.langs[lang].images.length ? (release.langs[lang].images[0].customthumb ? release.langs[lang].images[0].customthumb : release.langs[lang].images[0].preview) : "";
					let portrait = false;
					if (imageUrl) {
						portrait = release.langs[lang].images[0].portrait ? release.langs[lang].images[0].portrait : false;
					}
					$(".ordered_items").append(`<div class="ordered_item uk-hidden@s uk-margin-remove">
                ${
					imageUrl
						? `<div class="uk-cover-container ordered_image_wrapper uk-margin-bottom">
                    <a href="/${lang}/news/?id=${release.id}"><img uk-cover${portrait ? ` style="transform: translate(-50%,-44%);"` : ""} src="${imageUrl}"/></a>
                </div>`
						: ""
				}
                <div class="pubDate">${trans("Published on")} ${humanDate(release.langs[lang].pubTime)}</div>
                <div class="headline uk-heading-large uk-margin-small-bottom uk-margin-remove-top">
                    <a href="/${lang}/news/?id=${release.id}">${release.langs[lang].headline}</a>
                </div>
                <div class="summary uk-margin-bottom">
                    <span class="summary">${release.langs[lang].summary}</span>
                </div>
                <div class="read_more uk-text-small uk-margin-remove-top uk-margin-medium-bottom">
                    <a href="/${lang}/news/?id=${release.id}">${trans("Read News Release")}</a>
                </div>
            </div>
            <div class="ordered_item uk-visible@s uk-margin-large-bottom uk-width-1-2">
                ${
					imageUrl
						? `<div class="uk-cover-container ordered_image_wrapper uk-margin-bottom">
                    <a href="/${lang}/news/?id=${release.id}"><img uk-cover${portrait ? ` style="transform: translate(-50%,-33%);"` : ""} src="${imageUrl}"/></a>
                </div>`
						: ""
				}
                <div class="text_wrapper uk-padding-small uk-padding-remove-vertical">
                    <div class="pubDate uk-margin-small-bottom">${trans("Published on")} ${humanDate(release.langs[lang].pubTime)}</div>
                    <div class="headline uk-heading-medium uk-margin-small-bottom uk-margin-remove-top">
                        <a href="/${lang}/news/?id=${release.id}">${release.langs[lang].headline}</a>
                    </div>
                    <div class="summary uk-margin-bottom">
                        <span class="summary">${release.langs[lang].summary}</span>
                    </div>
                    <div class="read_more uk-margin-remove">
                        <a href="/${lang}/news/?id=${release.id}">${trans("Read News Release")}</a>
                    </div>
                </div>
            </div>`);
				});
			}
			// place remaining, ordered news releases on page,
			// if any exist
		} else {
			// there is a dark news item designated
			releasesWrapper.append(`<div id="dark_item" class="uk-padding-large uk-light uk-text-center">
                <div class="text_wrapper">
                    <div class="heading bold headline">${darkNews.langs[lang].headline}</div>
                    <div class="subhead">${darkNews.langs[lang].subhead && darkNews.langs[lang].subhead != "null" ? darkNews.langs[lang].subhead : darkNews.langs[lang].summary}</div>
                    <button class="read_more_button uk-button uk-button-light"><a data-translate-key="Latest Information" href="/${lang}/news?id=${darkNews.id}">Latest Information</a></button>
                </div>
            </div>`);
		}

		$("#banner_close_button").on("click", function (e) {
			e.preventDefault();
			$("#banner").hide();
		});
		if (userLevel === "admin") {
			let banner = $("#banner");
			let bannerText = $("#banner_text_wrapper");
			let bannerInput = $("#banner_input_wrapper");

			$("#bannerLanguage")
				.select2({
					minimumResultsForSearch: Infinity
				})
				.on("change", function () {
					bannerEditor = tinymce.get("bannerText").save();
					bannerSettings.banner[editLang] = bannerInput.find("textarea").val();
					// preserve contents of editor input in bannerSettings.banner

					editLang = $(this).val();
					tinymce.get("bannerText").execCommand("mceSetContent", false, bannerSettings.banner[editLang] ? bannerSettings.banner[editLang] : "");
				});
			// banner language select change handler

			$("#banner_reject")
				.off()
				.on("click", function (e) {
					e.preventDefault();
					tinymce.get("bannerText").destroy();
					bannerInput.addClass("hidden");
					bannerText.show();
					setTimeout(() => {
						banner.on("click", function (e) {
							e.preventDefault();
							editBanner();
						});
					}, 200);
				});
			// banner edit reject click handler

			$("#banner_accept")
				.off()
				.on("click", async function (e) {
					e.preventDefault();
					banner.append(dimmer());
					bannerEditor = tinymce.get("bannerText");
					bannerEditor.save();
					bannerEditor.destroy();
					// close editor and move value
					// into textarea

					const bannerVal = bannerInput.find("textarea").val();
					if (bannerSettings.banner) {
						bannerSettings.banner[editLang] = bannerVal;
					} else {
						bannerSettings.banner = {
							[editLang]: bannerVal
						};
					}
					try {
						await updateBanner(bannerSettings.banner);
						buildNewsSection(news, userLevel, modes);
					} catch (err) {
						console.error(err);
					}
				});
			// banner edit accept click handler

			banner.css("cursor", "pointer").on("click", function (e) {
				e.preventDefault();
				editBanner();
			});
			const editBanner = () => {
				tinymce.init({
					license_key: "gpl",
					selector: "textarea#bannerText",
					height: 150,
					width: "100%",
					skin: false,
					paste_as_text: true,
					content_css: `${location.pathname.indexOf("/dist/") > -1 ? `/dist/` : "/"}css/main.css`,
					plugins: "code autolink link lists paste",
					toolbar: "undo redo | bold italic underline strikethrough | formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | link | removeformat | paste | code",
					menubar: false /* 'file edit view insert format tools' */,
					menu: {
						file: { title: "File", items: "newdocument restoredraft | preview | print " },
						edit: { title: "Edit", items: "undo redo | cut copy paste | selectall | searchreplace" },
						view: { title: "View", items: "code | visualaid visualchars visualblocks | spellchecker | preview fullscreen" },
						insert: { title: "Insert", items: "link" },
						format: { title: "Format", items: "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontsizes align | removeformat" },
						tools: { title: "Tools", items: "spellchecker spellcheckerlanguage | code" }
					}
				});
				// initialize text editor
				banner.off("click");
				bannerText.hide();
				bannerInput.removeClass("hidden");
			};
			// banner text manager
		}
	}
	// there is news to present

	if (!$("#social_media_belt").length) {
		releasesWrapper.append(`<!-- social media belt -->
    <hr ${darkNews ? `class="dark_news" ` : ""}/>
    <div id="social_media_belt" class="uk-padding-large uk-padding-remove-vertical">
        <div class="uk-flex uk-flex-center uk-flex-wrap uk-flex-between@s uk-flex-middle@s uk-margin-large-top uk-margin-remove-bottom uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top">
            <div class="social_label uk-heading-medium uk-padding-remove uk-margin-remove">@GULFSTREAMAERO</div>
            <div class="social_icon_wrapper">
                <a href="https://www.facebook.com/gulfstreamaero" target="_blank" class="uk-icon-button">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="facebook">
                        <path d="M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z"></path>
                    </svg>
                </a>
                <a href="http://www.twitter.com/gulfstreamaero" target="_blank" class="uk-icon-button">
                    <svg version="1.1" id="Layer_1" style="height: 100%; width: auto;" stroke-width="2.5" stroke-miterlimit="10" sxmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 164.9 164.9" style="enable-background:new 0 0 164.9 164.9;" xml:space="preserve">
                        <path id="path1009" d="M55.3,57l21,28.1L55.1,108H60l18.5-20l15,20h16.2L87.5,78.2l19.7-21.3h-4.8L85.3,75.4L71.6,57H55.3z M62.3,60.5h7.4l32.9,44h-7.4L62.3,60.5z" />
                    </svg>
                </a>
                <a href="http://www.instagram.com/gulfstreamaero" target="_blank" class="uk-icon-button">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="instagram">
                        <path d="M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z"></path>
                        <circle cx="14.87" cy="5.26" r="1.09"></circle>
                        <path d="M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z"></path>
                    </svg>
                </a>
                <a href="https://www.linkedin.com/company/gulfstream-aerospace" target="_blank" class="uk-icon-button">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="linkedin">
                        <path d="M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z"></path>
                        <path d="M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z"></path>
                    </svg>
                </a>
                <a href="http://www.youtube.com/gulfstreamaero" target="_blank" class="uk-icon-button">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="youtube">
                        <path d="M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z"></path>
                    </svg>
                </a>
            </div>
        </div>
    </div>
    <hr class="uk-visible@s uk-margin-remove" />

	<!-- Instagram feed -->
    <div id="social_feed_container">
		<div id="curator-feed-gac-instagram-layout"><a href="https://curator.io" target="_blank" class="crt-logo crt-tag">Powered by Curator.io</a></div>    
    </div>`);

		let i,
			e,
			d = document,
			s = "script";
		i = d.createElement("script");
		i.async = 1;
		i.charset = "UTF-8";
		i.src = "https://cdn.curator.io/published/a4f9f1d5-5b25-44c6-865b-b7bf3b3533d6.js";
		e = d.getElementsByTagName(s)[0];
		e.parentNode.insertBefore(i, e);
		// try {
		// 	const response = await request(
		// 		{
		// 			reqId: "fac656f8-dc17-4c02-b625-8bed064d1022",
		// 			count: 10
		// 		},
		// 		// 		$("#social_media_belt")
		// 	);
		// 	const parsed = JSON.parse(JSON.parse(response).body);
		// 	if (parsed.success) {
		// 		let tweets = [];
		// 		parsed.data.forEach(tweet => {
		// 			if (tweet.extended_entities && tweets.length < 3) {
		// 				tweets.push(tweet);
		// 			}
		// 			// gather first three tweets with an extended_entities property
		// 		});
		// 		if (isSmall) {
		// 			$(".tweet_slider").append(`<ul id="twitter_slider_items" class="uk-slider-items uk-grid uk-grid-small"></ul>`);
		// 		}
		// 		tweets.forEach(tweet => {
		// 			let data = {
		// 				id_str: tweet.id_str,
		// 				type: tweet.extended_entities.media ? tweet.extended_entities.media[0].type : null,
		// 				media: tweet.extended_entities.media ? (tweet.extended_entities.media[0].media_url_https ? tweet.extended_entities.media[0].media_url_https : tweet.extended_entities.media[0].media_url) : null,
		// 				screenname: tweet.user.screen_name,
		// 				date: humanDate(new Date(tweet.created_at.replace(/\+\d{4}/, "")).getTime()),
		// 				retweets: tweet.retweet_count,
		// 				favorites: tweet.favorite_count,
		// 				text: tweet.full_text
		// 			};
		// 			if (data.type === "video") {
		// 				data.video_info = tweet.extended_entities.media[0].video_info;
		// 			}
		// 			let isVideo = data.video_info && data.video_info.variants.length ? true : false;
		// 			let links = [];
		// 			if (tweet.extended_entities.media && tweet.extended_entities.media[0].url) {
		// 				links.push(tweet.extended_entities.media[0].url);
		// 			}
		// 			if (tweet.entities && tweet.entities.urls && tweet.entities.urls.length) {
		// 				tweet.entities.urls.forEach(url => {
		// 					links.push(url.url);
		// 				});
		// 			}
		// 			data.links = links.length ? links : null;
		// 			// collect any links

		// 			if (tweet.entities && tweet.entities.hashtags && tweet.entities.hashtags.length) {
		// 				// are their hashtags? let's put them in the text
		// 				let text = tweet.full_text;
		// 				tweet.entities.hashtags.forEach(tag => {
		// 					// {
		// 					//     indices: [start,stop],
		// 					//     text: "hashtag text"
		// 					// }
		// 					let patt = new RegExp(`#${tag.text}`, "m");
		// 					text = text.replace(patt, `<a href="https://twitter.com/hashtag/${tag.text}?src=hashtag_click" target="_blank">#${tag.text}</a>`);
		// 				});
		// 				data.text = text;
		// 			}
		// 			if (data.links) {
		// 				// if there are links, let's make them live

		// 				data.links.forEach(link => {
		// 					let patt = new RegExp(link, "m");
		// 					data.text = data.text.replace(patt, `<a href="${link}" target="_blank">${link}</a>`);
		// 				});
		// 			}
		// 			let _tweet = `<div class="tweet uk-flex uk-flex-center uk-width-1-3@s">
		//                 <div>
		//                     ${
		// 						data.media && !data.video_info
		// 							? `<div class="uk-cover-container tweet_media_wrapper">
		//                         <a href="https://twitter.com/${data.screenname}/status/${data.id_str}" target="_blank"><img uk-cover src="${data.media}"/></a>
		//                     </div>`
		// 							: isVideo
		// 							? `<div class="uk-cover-container tweet_media_wrapper ${isVideo ? "video_tweet" : ""}">
		//                         <canvas width="16" height="9"></canvas>
		//                         <video src="${data.video_info.variants.find(variant => variant.content_type === "video/mp4").url}" uk-video="automute: true" loop muted playsinline uk-cover controls></video>
		//                     </div>`
		// 							: ""
		// 					}
		//                     <div class="uk-visible@m uk-flex uk-flex-between uk-flex-middle uk-margin uk-margin-remove-horizontal uk-text-small tweet_metadata">
		//                         <span>@${data.screenname}</span> <span>|</span> <span>${data.date}</span> <span>|</span> <span class="uk-flex uk-flex-middle">${data.retweets} <span class="retweet_icon uk-text-top" style="margin-left: 2px;" uk-icon="icon:retweet; ratio: .8"></span></span> <span>|</span> <span class="uk-flex uk-flex-middle">${data.favorites} <span style="margin-left: 2px;" uk-icon="icon:heart; ratio: .5"></span></span>
		//                     </div>
		//                     <div class="tweet_text">${data.text}</div>
		//                     <div class="tweet_share">
		//                         <a href="https://twitter.com/intent/retweet?tweet_id=${data.id_str}" target="_blank"><span class="twitter_link_copy" uk-icon="icon: twitter; ratio: 1"></span></a>
		//                     </div>
		//                 </div>
		//             </div>`;
		// 			if (isSmall) {
		// 				$("#twitter_slider_items").append(`<li class="tweet_slide">
		//                     ${_tweet}
		//                 </li>`);
		// 			} else {
		// 				$("#twitter_feed").append(_tweet);
		// 			}
		// 			// for mobile, wrap tweets in
		// 			// uk slider <ul><li> elements
		// 		});
		// 		// insert tweets
		// 	} else throw "Error fetching tweets";
		// } catch (err) {
		// 	console.error(err);
		// }
		// place tweets on page
	}
	// place social media feed on page if it doesn't exist

	$("#language_drop").on("toggle", function () {
		let icon = $("#language_drop_icon");
		let state = icon.attr("uk-icon");
		icon.attr("uk-icon", state === "icon: chevron-right" ? "icon: chevron-down" : "icon: chevron-right");
	});
};
// end buildNewsSection
